import { render, staticRenderFns } from "./CheckboxInputRenderer.vue?vue&type=template&id=774c8aa4"
import script from "./CheckboxInputRenderer.vue?vue&type=script&lang=js"
export * from "./CheckboxInputRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports